<template>
  <section
    class="component-c577191a"
    resmed-component-name="feature_fullwidth_icon-line_text_image_mobile_flex_3cta"
  >
    <div
      class="component"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
      v-bind:style="styles"
    >
      <div class="container px-xs-sm-2">
        <div class="row align-items-center">
          <div class="col-md-6 offset-lg-1 mb-5 mb-md-0">
            <figcaption>
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
              ></eyebrow-icon>
              <h2
                v-if="acf.layout['h-type'] === 'h2'"
                v-html="acf.headline"
              ></h2>
              <h1 v-else v-html="acf.headline"></h1>

              <p v-if="acf.content" class="mb-4" v-html="acf.content"></p>
            </figcaption>

            <div class="row items" v-if="acf.items">
              <div class="col-md-4" v-for="(item, index) in acf.items">
                <div class="content mb-5 mb-md-0">
                  <h5>{{ item.title }}</h5>
                  <p v-html="item.content"></p>
                </div>
              </div>
            </div>

            <div class="resources">
              <a
                v-for="item in acf.cta"
                v-bind:href="item.cta.href"
                v-bind:target="item.cta.target"
                class="btn cta-pill filled-red icon right-arrow mr-2 my-2"
                >{{ item.cta.text }}</a
              >
              <div class="d-flex">
                <a
                  v-if="acf['apple-app-store']"
                  target="_blank"
                  v-bind:href="acf['apple-app-store']"
                  class="btn apple-store d-block text-hide mr-1"
                  >Download on the App Store</a
                >
                <a
                  v-if="acf['google-play']"
                  target="_blank"
                  v-bind:href="acf['google-play']"
                  class="btn google-play d-block text-hide ml-1"
                  >Get it on Google Play</a
                >
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-5">
            <figure>
              <img class="img-fluid" v-bind:src="acf.image" alt="" />
            </figure>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-c577191a", // feature_fullwidth_icon-line_text_image_mobile_flex_3cta
  props: ["acf"],
  data() {
    return {
      styles: {
        "background-image": `url(${this.acf.layout["background-image"]})`,
        "background-position": "center center",
        "background-color": this.acf.layout["background-color"],
        "padding-top": undefined,
        "padding-bottom": undefined,
      },
    };
  },
  watch: {
    "$root.mode": {
      handler(val) {
        if (["md", "lg", "xl"].includes(val)) {
          (this.styles["padding-top"] = this.acf.layout["padding-top"]),
            (this.styles["padding-bottom"] = this.acf.layout["padding-bottom"]);
        } else {
          this.styles["padding-top"] = "4rem";
          this.styles["padding-bottom"] = "6rem";
          this.styles["background-position"] = "center top";

          if (this.acf.layout["background-image-xs"]) {
            this.styles[
              "background-image"
            ] = `url(${this.acf.layout["background-image-xs"]})`;
          }
        }
      },
      immediate: true,
    },
  },
  created() {
    bus.$emit("navigation:reversed", true);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-c577191a {
  // -->
}

.component {
  background-size: cover;
  background-repeat: no-repeat;

  &.text-color-black {
    h1,
    h2,
    h5,
    p {
      color: $cc-resmed-black;
    }

    h1,
    h2 {
      &:before {
        background-color: $cc-resmed-black;
      }
    }
  }

  h1,
  h2 {
    position: relative;
    color: rgba($cc-resmed-white, 0.875);

    @media (min-width: 768px) {
      margin: 0 0 1.325rem 0;
    }

    @extend %eyebrow-left;
    &:before {
      background-color: $cc-resmed-white;
    }
  }

  h5 {
    margin-bottom: 0.625rem;
  }

  figure {
    img {
      margin: 0 auto;
    }
  }

  .items {
    @media (min-width: 768px) {
      margin-bottom: 2.25rem;
    }

    * {
      color: $cc-resmed-white;
    }

    .content {
      @media (min-width: 992px) {
        padding-right: 3rem;
      }
    }
  }

  .resources {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
}
</style>